var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarClockOutline = function SvgCalendarClockOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2C16.667 2 17 2.31441 17 2.94141V4H18C19.333 4 20 4.667 20 6V10.252C19.3608 10.0874 18.6906 10 18 10H6V20H10.252C10.4347 20.71 10.7148 21.3806 11.0732 22H6C4.667 22 4 21.333 4 20V6.00391C4.00003 4.66797 4.66703 4 6 4H7V3C6.998 2.333 7.33 2 8 2C8.67 2 9.00391 2.333 9.00391 3V4H15V2.94141C15 2.31441 15.333 2 16 2ZM6 8H18V6H6V8Z",
    fill: "#3A3A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10.0882 16 10.1705 16.0059 10.2471 16.0176C10.0855 16.6515 10 17.3158 10 18H9C8.333 18.001 8 17.668 8 17C8 16.332 8.33498 15.999 9.00195 16H10Z",
    fill: "#3A3A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C10.667 12 11 12.333 11 13C11 13.667 10.667 14 10 14H9C8.333 14.001 8 13.668 8 13C8 12.332 8.33498 11.999 9.00195 12H10Z",
    fill: "#3A3A47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22ZM18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18C24 21.3137 21.3137 24 18 24Z",
    fill: "#3A3A47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15.25C18.4142 15.25 18.75 15.5858 18.75 16V17.6893L19.5303 18.4697C19.8232 18.7626 19.8232 19.2374 19.5303 19.5303C19.2374 19.8232 18.7626 19.8232 18.4697 19.5303L17.4697 18.5303C17.329 18.3897 17.25 18.1989 17.25 18V16C17.25 15.5858 17.5858 15.25 18 15.25Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarClockOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-clock-outline.9a8814ce.svg";
export { ForwardRef as ReactComponent };